import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionKycCddOrDefaults } from '@/features/institution/kyc-cdd/schema';

const InstitutionKycCddFieldsetCustomerDueDiligence = () => {
  const form = useFormContext<InstitutionKycCddOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="verifiesCustomerIdentity"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.customerDueDiligence.verifiesCustomerIdentity')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.customerDueDiligence.verifiesCustomerIdentity')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="knowsExpectedActivity"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.customerDueDiligence.knowsExpectedActivity')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.customerDueDiligence.knowsExpectedActivity')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="retainsOwnershipDocuments"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.customerDueDiligence.retainsOwnershipDocuments')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.customerDueDiligence.retainsOwnershipDocuments')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="verifiesNatureAndPurpose"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.customerDueDiligence.verifiesNatureAndPurpose')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.customerDueDiligence.verifiesNatureAndPurpose')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="verifiesSourceOfFunds"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.customerDueDiligence.verifiesSourceOfFunds')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.customerDueDiligence.verifiesSourceOfFunds')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionKycCddFieldsetCustomerDueDiligence.displayName = 'InstitutionKycCddFieldsetCustomerDueDiligence';

export { InstitutionKycCddFieldsetCustomerDueDiligence };
